import { useJsApiLoader } from '@react-google-maps/api';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string;

export const GOOGLE_MAP_ID = '87412a572f003751';

export const useGoogleMapsLoader = () =>
  useJsApiLoader({
    id: 'transport-routes-google-maps',
    googleMapsApiKey: API_KEY,
    mapIds: [GOOGLE_MAP_ID],
  });
